<template>
  <div v-loading="loading">
    <div style="margin-bottom: 20px">
      <el-button type="primary" size="small" @click="onOk">
        选择
      </el-button>
    </div>
    <bsp-table
			reduceHeight="130"
      :data.sync="list"
      ref="accountTable"
      @select-change="selectChange"
      @select-all="selectAll"
      :ciic-data-filter.sync="listQuery"
      @ciic-data-refresh="_getListpage"
      :showPagination="listQuery.page"
      show-footer
      fixed="left"
    >
      <vxe-table-column
        type="selection"
        width="60"
        fixed="left"
      />
      <vxe-table-column
        fixed="left"
        type="index"
        title="序号"
        width="60"
      />

      <bsp-table-column
        field="id"
        filter-type="input"
        :showPagination="false"
        :visible="false"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="A0010002"
        title="姓名"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="A0010004"
        title="证件类型"
        filter-type="select"
        set-id="3159"
        filterable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.idCardType |dictFilter(dicts)}}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="A0010005"
        title="证件号码"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.idCard }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="A0010024"
        title="成本中心"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.costCenter }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="A0010039"
        title="入职时间"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.entryTime }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="A0010040"
        title="离职时间"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.depaTime }}</span>
        </template>
      </bsp-table-column>

    </bsp-table>
  </div>
</template>

<script>
  import defaultInvoice from "@/components/bsp/bsp-dicts-invoice/default";
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import { queryPersonListPage,getCusData } from  "@/api/wage/payGroup";
  import { getEmpListOfSelect } from  "@/api/emp/emp";
  import { addSaveItemData } from  "@/api/wage/batchTemplate"
  import { mapGetters } from 'vuex';
  export default {
    name: "Table",
    components: { bspTableColumn, bspTable},
    props:{
      perDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      payGroupId:{
        type:Number,
        default:0
      },
      batchId:{
        type:Number,
        default:0
      },
      templateId:{
        type:Number,
        default:0
      },
      taxType:{
        type:Number,
        default:0
      },
      orgId:{
        type:Number,
        default:0
      },
      wageMonth:{
        type:String,
        default:''
      },
      socMonth:{
        type:String,
        default:''
      },
      taxMonth:{
        type:String,
        default:''
      },
      payWay:{
        type:String,
        default:''
      },
      isCompute:{
        type:String,
        default:''
      },
      outPerDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      state: {
        type: String,
        default: '',
      },
      regionId: {
        type: String,
        default: '',
      },
      cusId:{
        type:String,
        default:''
      }
    },
    created(){

      this._getCusData();

    },
    mounted() {

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data(){
      return{
        dialogheaderVisible:false,
        loading:false,
        orgIds:[],
        list: [],
        perList:[],
        multipleSelection: [],
        listQuery:{
          limit:20,
          page:1,
          total:0,
          orgMap:{},
          orgList:[],
          perDatas:[],
          outPerDatas:[],
          state:"",
          sameBatchId:"NO",
          cusId:this.cusId
        },
      }
    },
    methods: {

      //复选框全选事件
      selectAll({checked, selection}){
        this.multipleSelection = selection;
        console.log("全选-----",JSON.stringify(this.multipleSelection))
      },
      _getCusData(){
          const that = this;
          getCusData().then((res) => {
              this.cusId= res.data.data.cusId;
              this.listQuery.cusId = res.data.data.cusId;
              this._getListpage();
          });
      },
      //获取列表数据
      _getListpage(e){
        if(e!=undefined){
          this.listQuery.orgList = e;
        }
        this.listQuery.perDatas = this.perDatas;
        this.listQuery.outPerDatas = this.outPerDatas;
        this.listQuery.state = this.state;
        this.listQuery.cusId = this.cusId;
        getEmpListOfSelect(this.listQuery).then(res => {
          console.log("使用getEmpListOfSelect调用后台res=",res)
           this.listQuery.total = res.data.total;
           this.list = res.data.records;
        })
      },

      //批量更改状态
      selectChange({checked, row}){
        if(checked){
          this.multipleSelection.push(row)
        }
        if(!checked){
          this.multipleSelection.filter((item,index) => {
            if(item===row){
              this.multipleSelection.splice(index,1)
            }
          })
        }

      },

      onOk(){
        let params = {
          payGroupId:this.payGroupId,//薪酬组id
          batchId:this.batchId,//批次信息id
          templateId:this.templateId,//模板信息id
          taxType:this.taxType,//计税类型
          wageMonth: this.wageMonth,//工资月份
          socMonth: this.socMonth,//社保月份
          taxMonth: this.taxMonth,//税金月份
          payWay: this.payWay,//付款方式
          isCompute: this.isCompute,//是否计算
          regionId: this.regionId,//服务组合ID
          orgId:this.orgId//组织结构id
        }
        console.log("新增传参数据====",params)

        let listSize=this.multipleSelection.length;
        if(listSize==0){
          this.$message.error('请选择至少选中一行')
        }else{
          let obj = {dialog:this.dialogheaderVisible,data:this.multipleSelection}
          let idCardList = []
          this.multipleSelection.forEach(item=>{
              if(item.idCard){
                idCardList.push(item.idCard);
              }
          })
          //调用数据新增保存接口
          this.$confirm('是否确认提交新增数据?','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            this.loading=true;
            this.dialogheaderVisible = false;
            let data ={
              params:params,
              idCardList:idCardList
            }
            // let dataJson = JSON.parse(JSON.stringify(data))
            addSaveItemData(data).then(res=>{
              this.loading=false;
              let re = res.data;
              if(re.code == 0){
                this.$message.success("新增成功");
              }
              this.$emit('personDatas',obj);//调用关闭页面
              this.$emit('_getSalaryHistoryData');//调用父类方法刷新
            });

          })
          console.log("多选确认数据证件号---:",idCardList);
        }
      },
    },

  }
</script>

<style scoped>

</style>
